import React from 'react';

import { ForgotPassword } from 'presentation/pages';

export const MakeForgotPasswordFactory: React.FC = () => {
  return <ForgotPassword />;
};
